// extracted by mini-css-extract-plugin
module.exports = {"stepperButton":"style_stepperButton__2tm8m"};